import { EnvironmentInterface } from "../environment-interface";

export const environment: EnvironmentInterface = {
  production: true,
  envName: "demonstracao",
  apiURL: "https://demo-serv.idba.com.br/api-idba/",
  apiURLLogin: "https://demo-serv.idba.com.br/api-idba/v3/authenticate/",
  apiURLChangePassword: "https://demo-serv.idba.com.br/api-idba/v3/change-password/",
  apiURLResetPassword: "https://demo-serv.idba.com.br/api-idba/v3/reset-password/",
  apiURLIntegrate: "https://demo-serv.idba.com.br/api-idba/v3/integrate/",
  envDesc: "i7Code - Demonstração - Serviço",
  timeout: 3000000,
  encryptionKey: "_iDB@Fram3w0rk_&Rp",
  classToolbar: "",
  imagemLogo: "",
  indLogoEmpresa: false,
  service: false,
  debugRoutes: false,
  passwordMinSize: 8,
  passwordMaxSize: 12,
  passwordValidateUppercase: true,
  passwordValidateLowercase: true,
  passwordValidateNumber: true,
  passwordValidateSpecialChar: true
};